import type {ICookieCategoriesPreferences} from 'consent-banner'
import {ConsentControl} from 'consent-banner'
import {useEffect, useRef} from 'react'
import {getPreferencesFromCookie, setPreferencesToCookie} from '@github-ui/cookie-consent'

import {DefaultCookieConsentPreferences, cookieCategories, consentControlOptions} from './lib/configuration'

type Props = {
  cookieConsentRequired: boolean
  initialCookieConsentAllowed: boolean
}

export function CookieConsentManagement({cookieConsentRequired, initialCookieConsentAllowed}: Props) {
  const manageConsent = useRef(() => {})

  useEffect(() => {
    const existingCookiePreferences = getPreferencesFromCookie()

    const onPreferenceChange = (preferences: ICookieCategoriesPreferences) => {
      setPreferencesToCookie(preferences)
      consentControl.hideBanner()
    }

    const consentControl = new ConsentControl(
      'cookie-consent-banner',
      'en',
      onPreferenceChange,
      cookieCategories,
      consentControlOptions,
    )

    manageConsent.current = () => {
      consentControl.showPreferences(getPreferencesFromCookie() || {})
    }

    if (existingCookiePreferences === null && initialCookieConsentAllowed && cookieConsentRequired) {
      consentControl.showBanner(DefaultCookieConsentPreferences.Required)
    }

    if (existingCookiePreferences === null && initialCookieConsentAllowed && !cookieConsentRequired) {
      setPreferencesToCookie(DefaultCookieConsentPreferences.NotRequired)
    }
  }, [cookieConsentRequired, initialCookieConsentAllowed])

  return (
    <>
      <button
        type="button"
        className="Link--secondary underline-on-hover border-0 p-0 color-bg-transparent mx-2"
        onClick={() => manageConsent.current()}
      >
        Manage cookies
      </button>

      <button
        type="button"
        className="Link--secondary underline-on-hover border-0 p-0 color-bg-transparent mx-2"
        onClick={() => manageConsent.current()}
      >
        Do not share my personal information
      </button>

      <div id="cookie-consent-banner" className="position-fixed bottom-0 left-0" style={{zIndex: 999999}} />
    </>
  )
}

try{ CookieConsentManagement.displayName ||= 'CookieConsentManagement' } catch {}